import React from 'react'
import { useIntl } from 'react-intl'
import Image from 'components/Common/Image/Image'
import styled from 'styled-components'
import { rem } from 'polished'

const ImageContainer = styled.div`
  position: relative;
  min-height: ${rem(100)};
  width: 100%;
  aspect-ratio: 3.3 / 1;
  overflow: hidden;
`

function HelloFreshModalImage() {
  const intl = useIntl()

  return (
    <ImageContainer>
      <Image
        image={{ id: 'hello-fresh-promo' }}
        fit="center"
        objectFit="cover"
        alt={intl.formatMessage({
          id: 'CjWQ4Z9DDUQFg1fxR-lU',
          defaultMessage: 'Hello Fresh promotional image',
          description: 'Alternative text for the Hello Fresh partner promotion image in the modal',
        })}
      />
    </ImageContainer>
  )
}

export default HelloFreshModalImage
